export enum AthrOperationCardStatusEnum {
  EXPIRED = 'EXPIRED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  INACTIVE = 'INACTIVE',
  WAITING_TO_ISSUE_LETTERS = 'WAITING_TO_ISSUE_LETTERS',
  WAITING_FOR_CHANGE_VEHICLES_PLATE_TYPE = 'WAITING_FOR_CHANGE_VEHICLES_PLATE_TYPE',
  UNDER_CANCELLATION = 'UNDER_CANCELLATION',
  UNDER_CHANGING = 'UNDER_CHANGING',
  CANCELLED_BY_SYSTEM = 'CANCELLED_BY_SYSTEM',
}
